import React, { memo, ReactNode, useMemo } from 'react';

import { TextField } from '~/UIKit';
import { FormikProps } from 'formik';

interface ITextFieldCommon {
  type: 'text' | 'number';
  name: string;
  className: string;
  value: any;
  icon?: ReactNode;
  label?: ReactNode;
  placeholder?: ReactNode;
  disabled?: boolean;
  formDisabled?: boolean;
  InputProps: any;
  errors: any;
  touched: any;
  handleBlur: FormikProps<any>['handleBlur'];
  handleChange: FormikProps<any>['handleChange'];
}

export const TextFieldCommon = memo(
  ({
    icon,
    type,
    name,
    value = type === 'number' ? 0 : '',
    label,
    errors,
    touched,
    disabled,
    className,
    InputProps,
    placeholder,
    formDisabled,
    handleBlur: onBlur,
    handleChange: onChange,
  }: ITextFieldCommon) => {
    const field = useMemo(
      () => ({
        name,
        value,
        onBlur,
        onChange,
      }),
      [name, value, onBlur, onChange],
    );
    return (
      <TextField
        field={field}
        key={name}
        name={name}
        type={type}
        icon={icon}
        label={label}
        error={!!touched && !!errors}
        value={value}
        disabled={disabled || formDisabled}
        fullWidth
        newDesign
        className={className}
        placeholder={placeholder || label}
        {...InputProps}
      />
    );
  },
);
